import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { currentOrigin } from '@glass/env/modules/origins/constants';

import JsonLDHead from '@glass/shared/components/Head/JsonLDHead';
import useSrc from '@glass/shared/components/Image/helpers/useSrc';

function NewsArticleStructuredData({ path, title, heroImage, publishedAt, updatedAt, authorName }) {
  const image = useSrc({ path: heroImage, width: 1200 });
  const schema = useMemo(() => {
    return {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': `${currentOrigin}${path || ''}`,
      },
      headline: title,
      image: [image],
      datePublished: publishedAt,
      dateModified: updatedAt,
      author: {
        '@type': 'Person',
        name: authorName,
      },
      publisher: {
        '@type': 'Organization',
        name: process.env.NEXT_PUBLIC_BRAND_TITLE,
      },
    };
  }, [path, title, image, publishedAt, updatedAt, authorName]);

  if (!title || !publishedAt || !path || !heroImage || !authorName) {
    if (__DEV__) {
      console.warn(
        `invalid props for news article ${[
          title,
          publishedAt,
          path,
          heroImage,
          authorName,
        ].join()}`,
      );
    }
    return null;
  }

  return <JsonLDHead schema={schema} />;
}

NewsArticleStructuredData.propTypes = {
  authorName: PropTypes.string,
  heroImage: PropTypes.string.isRequired,
  path: PropTypes.string,
  publishedAt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
};

export default React.memo(NewsArticleStructuredData);
